<template>
  <div>
    <!-- <ParentBar />
    <AccountingParentBar />-->
    <layout :isSuccess="true">
      <template v-slot:containerZone>
        <div class="my-4">
          <v-row class="bg-white mx-0">
            <v-col cols="12" class="text-center">
              <h1>{{ $t('invoice.title') }}</h1>
            </v-col>
            <v-col cols="10">
              <v-row>
                <v-col cols="6">
                  <v-menu v-model="menuStartDate" :close-on-content-click="false" transition="scale-transition" offset-y
                    max-width="290px" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field :value="$helper.datelabel(formData.startDate)" :placeholder="$t('date')" outlined dense
                        hide-details readonly v-bind="attrs" v-on="on" :label="$t('from_date')"></v-text-field>
                    </template>
                    <v-date-picker v-model="formData.startDate" no-title locale="th" @input="menuStartDate = false"
                      :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                      :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-menu v-model="menuEndDate" :close-on-content-click="false" transition="scale-transition" offset-y
                    max-width="290px" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field :value="$helper.datelabel(formData.endDate)" :placeholder="$t('date')" outlined dense
                        hide-details readonly v-bind="attrs" v-on="on" :label="$t('to_date')"></v-text-field>
                    </template>
                    <v-date-picker v-model="formData.endDate" no-title locale="th" @input="menuEndDate = false"
                      :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                      :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="2" class="text-center">
              <v-btn @click="initData()" class="primary" block :disabled="isLoading">
                <v-icon>mdi-magnify</v-icon>{{ $t('search') }}
              </v-btn>
            </v-col>
            <template v-if="isFristTime">
              <v-col cols="12" class="text-center grey lighten-4 pt-10">
                <h4 class="text-gray-400">{{ $t('validate.please_select_date_and_search') }}</h4>
              </v-col>
            </template>
            <template v-if="!isFristTime">
              <v-col cols="12" class="text-center pt-5 grey lighten-4">
                <h2>
                  <b>{{ $t('date_list') }}</b>
                  {{ $helper.datelabel(tempDate.startDate) }} -
                  {{ $helper.datelabel(tempDate.endDate) }}
                </h2>
                <div class="text-end py-3">
                  <!-- <v-btn @click="exportInvoice()" class="blue white--text" :disabled="isLoading">
                    <v-icon class="me-2">mdi-file-excel-outline</v-icon>
                    Export to SAGE
                  </v-btn>-->
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="blue white--text mx-1"
                        :disabled="isLoading"
                        :loading="isLoadingExportToERP"
                      >
                        <v-icon class="me-2">mdi-file-excel-outline</v-icon>
                        Export to ERP
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="exportMangoInvoice()">
                        <v-list-item-title>Mango</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-btn
                    :disabled="isLoading"
                    @click="exportInvoice()"
                    class="blue white--text mx-1"
                    :loading="isLoadingExportExcel"
                  >
                    <v-icon class="me-2">mdi-file-excel-outline</v-icon>
                    Export Excel
                  </v-btn>
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="blue white--text mx-1"
                        :disabled="isLoading"
                        v-bind="attrs"
                        v-on="on"
                        :loading="isLoadingReportVat"
                      >
                        <v-icon class="me-2">mdi-file-excel-outline</v-icon>
                        {{ $t('tax.tax_sell_report') }}
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="initReportVat('default_group')">
                        <v-list-item-title>{{ $t('tax.tax_sell_report_split_market') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="initReportVat('default_non_group')">
                        <v-list-item-title>{{ $t('tax.tax_sell_report_total_market') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="initReportVat('split_group')">
                        <v-list-item-title>{{ $t('tax.tax_sell_report_split_tax_split_market') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="initReportVat('split_non_group')">
                        <v-list-item-title>{{ $t('tax.tax_sell_report_split_tax_total_market') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu v-if="!isShowSelectPrintInvoice">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="blue white--text mx-1" :disabled="isLoading" v-bind="attrs" v-on="on">
                        <v-icon class="me-2">mdi-printer</v-icon>{{ $t('invoice.print_invoice') }}
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="printInvoice('all')">
                        <v-list-item-title>{{ $t('bill.print_all') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="choosePrintInvoice('select')">
                        <v-list-item-title>{{ $t('bill.select_bill') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="choosePrintInvoice('unpaid')">
                        <v-list-item-title>{{ $t('bill.select_bill_pending') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="choosePrintInvoice('paid')">
                        <v-list-item-title>{{ $t('bill.select_bill_paid') }}</v-list-item-title>
                      </v-list-item>
                      <!-- <v-list-item @click="choosePrintInvoice('all')">
                        <v-list-item-title>เลือกบิลทั้งหมด</v-list-item-title>
                      </v-list-item>-->
                    </v-list>
                  </v-menu>
                  <template v-else>
                    <v-btn class="info mx-1" @click="printInvoice('select')"
                      :disabled="isLoading || selectedInvoices.length <= 0">
                      <v-icon left>mdi-printer</v-icon>
                      {{ $t('bill.print_bill', { count: selectedInvoices.length }) }}
                    </v-btn>
                  </template>
                  <v-btn v-show="isShowSelectPrintInvoice" class="error mx-1"
                    @click="selectedInvoices = []; isShowSelectPrintInvoice = false;">{{ $t('cancel') }}</v-btn>
                </div>
              </v-col>
              <v-col v-if="!isFirstLoading" cols="12" class="px-0 pt-0 pb-4 grey lighten-4">
                <v-data-table 
                  v-if="dataTable && dataTable.data"
                  :headers="dataTable.headers"
                  :items="dataTable.data"
                  :items-per-page="10"
                  class="elevation-1 data-table-invoice"
                  item-key="objectId"
                  @click:row="rowClick"
                  v-model="selectedInvoices"
                  :show-select="isShowSelectPrintInvoice"
                  :single-select="false"
                  ref="dataTableInvoice"
                  :loading="isLoading"
                  :footer-props="{
                    'items-per-page-options': [10, 20, 50, 100],
                  }"
                  :no-data-text="$t('noinfo')"
                  :no-results-text="$t('no_matching_records_found')"
                >
                  <template v-slot:header.marketName="{header}">
                    <div class="text-nowrap-table text-center" style="min-width: 150px;">{{header.text}}</div>
                  </template>
                  <template v-slot:header.areaName="{header}">
                    <div class="text-nowrap-table text-center" style="min-width: 150px;">{{header.text}}</div>
                  </template>
                  <template v-slot:header.customerDataName="{header}"> 
                    <div class="text-nowrap-table text-center" style="min-width: 150px;">{{header.text}}</div>
                  </template>
   
                  <template v-slot:body.prepend>
                    <tr>
                      <td class="text-center">
                        <v-icon>mdi-filter-multiple-outline</v-icon>
                      </td>
                      <td class="ps-0">
                        <v-text-field v-model="filterData.marketName" type="text" :label="$t('market.market')" solo dense hide-details @input="onFilterChange"/>
                      </td>
                      <td class="ps-0">
                        <v-text-field v-model="filterData.documentId" type="text" :label="$t('market.document_id')" solo dense
                          hide-details @input="onFilterChange"/>
                      </td>
                      <td class="ps-0">
                        <v-select v-model="filterData.documentType" :items="filterOption.documentType" type="text"
                          :label="$t('type')" solo dense hide-details clearable :no-data-text="$t('noinfo')" @change="onFilterChange"/>
                      </td>
                      <td class="ps-0">
                        <v-text-field v-model="filterData.areaName" type="text" :label="$t('market.market_title')" solo dense hide-details @input="onFilterChange"/>
                      </td>
                      <td class="ps-0">
                        <v-text-field v-model="filterData.customerName" type="text" :label="$t('market.marchant_name')" solo dense
                          hide-details @input="onFilterChange"/>
                      </td>
                      <td class="ps-0 pe-0">
                        <v-currency-field v-model="filterData.totalValue" class="input-right input-disable-appearance"
                          :label="$t('market.total_value')" solo dense hide-details @input="onFilterChange"/>
                      </td>
                      <td :class="$helper.currencyOptions.length <= 1 ? 'd-none' : ''">
                        <v-select v-model="filterData.currencyCode" :items="$helper.currencyOptions" item-text="textThEn" item-value="value" type="text" :label="$t('payment.currency')" solo
                          dense hide-details clearable :disabled="isLoading" :no-data-text="$t('noinfo')" @change="onFilterChange"/>
                      </td>
                      <td>
                        <v-select v-model="filterData.status" :items="filterOption.status" type="text" :label="$t('status')" solo
                          dense hide-details clearable :no-data-text="$t('noinfo')" @change="onFilterChange"/>
                      </td>
                    </tr>
                  </template>
                  <template v-slot:item.data-table-select="{ isSelected, select, item }">
                    <template v-if="isShowSelectPrintInvoice && item.isSent">
                      <v-simple-checkbox color="primary" :value="isSelected" @input="select($event)"></v-simple-checkbox>
                    </template>
                  </template>
                  <!-- @click:row="onTableRowClick" -->
                  <template v-slot:item.date="{ item }">
                    <template v-if="item.date">{{ $moment(item.date).format("DD/MM/YYYY") }}</template>
                  </template>
                  <template v-slot:item.documentTypeString="{ item }">
                    <div class="text-no-wrap text-center">{{ item.documentTypeString }}</div>
                  </template>
                  <template v-slot:item.marketName="{ item }">
                    <div class="text-truncate text-start market-name">{{ item.marketName }}</div>
                  </template>
                  <template v-slot:item.areaName="{ item }">
                    <div class="text-truncate text-start area-name">{{ item.areaName }}</div>
                  </template>
                  <template v-slot:item.customerDataName="{ item }">
                    <div class="text-truncate text-start customer-name">{{ item.customerDataName }}</div>
                  </template>
                  <template v-slot:item.dueDate="{ item }">
                    <template v-if="item.dueDate">{{ $moment(item.dueDate).format("DD/MM/YYYY") }}</template>
                  </template>
                  <template v-slot:item.status="{ item }" class="text-center">
                    <v-chip :class="item.statusClass.class" :color="item.statusClass.color">
                      {{ item.statusClass.text }}
                    </v-chip>
                    <v-chip class="ms-1 px-0 py-0" color="rgb(255, 137, 59, 0.3)" v-if="item.invoicePayment">
                      <img width="32" :src="require(`../../assets/images/money-sign-orange.svg`)" />
                    </v-chip>
                  </template>
                  <template v-slot:item.totalValue="{ item }">
                    <div class="text-end">
                      {{ item.totalValue | currency }}
                    </div>
                  </template>
                  <template v-slot:item.currencyCode="{ item }">
                    <div class="text-center">{{ $helper.currencyThEn(item.currencyCode || 'THB') }} </div>
                  </template>
                </v-data-table>
              </v-col>
              <v-col v-else>
                <v-card class="d-flex justify-center py-10">
                  <v-progress-circular indeterminate size="64" color="green"></v-progress-circular>
                </v-card>
              </v-col>
            </template>
          </v-row>
        </div>

        <div class="my-5" v-if="!isFirstLoading && dataTable && dataTable.data">
          <template v-if="$helper.currencyOptions.length > 1">
            <v-tabs
              v-model="tab"
              color="primary"
              slider-color="primary"
              background-color="white"
              class="tab-custom-inline">
              <template v-for="currency in $helper.currencyOptions">
                <v-tab :value="currency.value" :href="`#${currency.value}`" :key="currency.value">
                  <img :src="`/images/currency/${currency.value}.svg`" :alt="currency.value" class="mr-2 tab-icon-flag">
                  {{ currency.tabName }}
                </v-tab>
              </template>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item key="THB" value="THB">
                <CardInvoiceOverAll v-if="!isLoadingCardOverAll" :invoices="filteredInvoices.length ? filteredInvoices : []" :tabType="`THB`"/>
              </v-tab-item>
              <v-tab-item key="LAK" value="LAK">
                <CardInvoiceOverAll v-if="!isLoadingCardOverAll" :invoices="filteredInvoices.length ? filteredInvoices : []" :tabType="`LAK`"/>
              </v-tab-item>
              <v-tab-item key="USD" value="USD">
                <CardInvoiceOverAll v-if="!isLoadingCardOverAll" :invoices="filteredInvoices.length ? filteredInvoices : []" :tabType="`USD`"/>
              </v-tab-item>
            </v-tabs-items>
          </template>
          <template v-else>
            <v-card elevation="0">
              <CardInvoiceOverAll v-if="!isLoadingCardOverAll" :invoices="filteredInvoices.length ? filteredInvoices : []" :tabType="tab"/>
            </v-card>
          </template>
        </div>

      </template>
    </layout>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <InvoiceDialog v-model="isInvoiceDialog" :invoiceId="invoiceId" :projectId="projectId" />
    <PrintDialog elementId="print-invoice-project-accounting" type="invoice" v-model="isPrintDialog"
      :invoiceIds="selectedInvoices.map(d => d.objectId)" />
    <v-dialog v-model="isPrintReportVat" v-if="isPrintReportVat" width="1000" @keydown.esc="isPrintReportVat = false"
      persistent>
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center blue white--text py-2">
          <template>{{ $t('tax.tax_sell_report') }}</template>
        </v-card-title>
        <iframe width="100%" height="500px" frameborder="0" name="iframe-report-vat" id="iframe-report-vat"></iframe>
        <div style="display: none;">
          <div style="height: 500px; overflow: scroll; font-family: 'Sarabun' !important;" id="report-vat-data">
            <template
              v-if="isEmpty(invoiceVatGroup) && isEmpty(invoiceNonGroup) && (typeSelectInvoice == 'default_group' || typeSelectInvoice == 'default_non_group')">
              <div class="paper A4" v-for="(mk, index) in markets" :key="'paper_' + index">
                <template v-if="typeOnButtonInvoice == 'showFirstMarket'">
                  <template v-if="index == 0">
                    <section class="sheet" id="sheet">
                      <div class="page" style="padding: 5mm; font-size: 13px;">
                        <table width="100%" style="font-weight: bold; font-size: 13px;margin-bottom: 7px;">
                          <tr>
                            <td>{{ $t('tax.tax_sell_report') }}</td>
                            <td class="text-right">{{ $t('page_message', { page: 1, total: 1 }) }}</td>
                          </tr>
                        </table>
                        <table width="100%" style="font-weight: bold; font-size: 13px;">
                          <tr>
                            <td width="20%">{{ $t('market.business_owner_name') }}</td>
                            <td>
                              <template v-if="mk.companyData && mk.companyData.name">
                                {{ mk.companyData.name }}
                              </template>
                              <template v-else>
                                {{ mk.name }}
                              </template>
                            </td>
                            <td width="20%">
                              <div
                                v-if="!mk.companyData || !mk.companyData.branchName || mk.companyData.branchName == 'สำนักงานใหญ่'"
                                style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <title>checkbox-outline</title>
                                  <path
                                    d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                                </svg>
                              </div>
                              <div v-else
                                style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <title>checkbox-blank-outline</title>
                                  <path
                                    d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                                </svg>
                              </div>
                              {{ $t('market.main_office') }}
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t('market.business_name') }}</td>
                            <td>
                              <template v-if="mk.companyData && mk.companyData.name">
                                {{ mk.companyData.name }}
                              </template>
                              <template v-else>
                                {{ mk.name }}
                              </template>
                            </td>
                            <td>
                              <template
                                v-if="!mk.companyData || !mk.companyData.branchName || mk.companyData.branchName == 'สำนักงานใหญ่'">
                                <div
                                  style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <title>checkbox-blank-outline</title>
                                    <path
                                      d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                                  </svg>
                                </div>
                                {{ $t('market.branch_office_number', { number: '' }) }} . . . . .
                              </template>
                              <template v-else>
                                <div
                                  style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <title>checkbox-outline</title>
                                    <path
                                      d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                                  </svg>
                                </div>
                                {{ $t('market.branch_office_number', { number: mk.companyData ? mk.companyData.branchName : '' }) }}
                              </template>
                            </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>{{ mk.companyData ? mk.companyData.address : '' }}</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td colspan="3">{{ $t('tax.tax_id', { taxId: mk.companyData ? mk.companyData.taxId : '' }) }}
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t('receipt.print_date', { date: $moment().format("DD/MM/YYYY") }) }}</td>
                            <td class="text-center">{{ $t('receipt.print_date_range', { startDate: $moment(tempDate.startDate).format("DD/MM/YYYY"), endDate: $moment(tempDate.endDate).format("DD/MM/YYYY") }) }}</td>
                            <td class="text-right">{{ $t('receipt.print_time', { time: $moment().format("HH:mm") }) }}</td>
                          </tr>
                        </table>
                        <table width="100%" class="report-vat-table">
                          <tr style="border-top: 1px solid black;border-bottom: 1px solid black;">
                            <th class="text-center">{{ $t('day') }} {{ $t('month') }} {{ $t('year') }}</th>
                            <th>{{ $t('number') }}</th>
                            <th>{{ $t('customer.customer_and_service_name') }}</th>
                            <th class="text-center">{{ $t('tax.tax_id', { taxId: '' }) }}</th>
                            <th class="text-center">{{ $t('market.main_and_branch_office') }}</th>
                            <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.no_tax') }}</th>
                            <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.before_tax') }}</th>
                            <th class="text-center">{{ $t('tax.title') }}<br />{{ $t('tax.vat') }}</th>
                            <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.total_tax') }}</th>
                          </tr>
                          <tr>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                          </tr>
                          <tr>
                            <td colspan="4"></td>
                            <td class="text-center"><b>{{ $t('sum') }}</b></td>
                            <td class="text-right">{{ 0 | currency }}</td>
                            <td class="text-right">{{ 0 | currency }}</td>
                            <td class="text-right">{{ 0 | currency }}</td>
                            <td class="text-right">{{ 0 | currency }}</td>
                          </tr>
                        </table>
                        <div style="border-top: 1px solid black; margin-top: 10px">
                          ({{ $t('receipt.receipt_count', { count: 0 }) }})
                        </div>
                      </div>
                    </section>
                  </template>
                </template>
                <template v-else-if="typeOnButtonInvoice == 'showAllMarket'">
                  <section class="sheet" id="sheet">
                    <div class="page" style="padding: 5mm; font-size: 13px;">
                      <table width="100%" style="font-weight: bold; font-size: 13px;margin-bottom: 7px;">
                        <tr>
                          <td>{{ $t('tax.tax_sell_report') }}</td>
                          <td class="text-right">{{ $t('page_message', { page: 1, total: 1 }) }}</td>
                        </tr>
                      </table>
                      <table width="100%" style="font-weight: bold; font-size: 13px;">
                        <tr>
                          <td width="20%">{{ $t('market.business_owner_name') }}</td>
                          <td>
                            <template v-if="mk.companyData && mk.companyData.name">
                              {{ mk.companyData.name }}
                            </template>
                            <template v-else>
                              {{ mk.name }}
                            </template>
                          </td>
                          <td width="20%">
                            <div
                              v-if="!mk.companyData || !mk.companyData.branchName || mk.companyData.branchName == 'สำนักงานใหญ่'"
                              style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <title>checkbox-outline</title>
                                <path
                                  d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                              </svg>
                            </div>
                            <div v-else
                              style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <title>checkbox-blank-outline</title>
                                <path
                                  d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                              </svg>
                            </div>
                            {{ $t('market.main_office') }}
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t('market.business_name') }}</td>
                          <td>
                            <template v-if="mk.companyData && mk.companyData.name">
                              {{ mk.companyData.name }}
                            </template>
                            <template v-else>
                              {{ mk.name }}
                            </template>
                          </td>
                          <td>
                            <template
                              v-if="!mk.companyData || !mk.companyData.branchName || mk.companyData.branchName == 'สำนักงานใหญ่'">
                              <div
                                style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <title>checkbox-blank-outline</title>
                                  <path
                                    d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                                </svg>
                              </div>
                              {{ $t('market.branch_office_number', { number: '' }) }} . . . . .
                            </template>
                            <template v-else>
                              <div
                                style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <title>checkbox-outline</title>
                                  <path
                                    d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                                </svg>
                              </div>
                              {{ $t('market.branch_office_number', { number: mk.companyData ? mk.companyData.branchName : '' }) }}
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>{{ mk.companyData ? mk.companyData.address : '' }}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="3">{{ $t('tax.tax_id', { taxId: mk.companyData ? mk.companyData.taxId : '' }) }}</td>
                        </tr>
                        <tr>
                          <td>{{ $t('receipt.print_date', { date: $moment().format("DD/MM/YYYY") }) }}</td>
                          <td class="text-center">{{ $t('receipt.print_date_range', { startDate: $moment(tempDate.startDate).format("DD/MM/YYYY"), endDate: $moment(tempDate.endDate).format("DD/MM/YYYY") }) }}</td>
                          <td class="text-right">{{ $t('receipt.print_time', { time: $moment().format("HH:mm") }) }}</td>
                        </tr>
                      </table>
                      <table width="100%" class="report-vat-table">
                        <tr style="border-top: 1px solid black;border-bottom: 1px solid black;">
                          <th class="text-center">{{ $t('day') }} {{ $t('month') }} {{ $t('year') }}</th>
                          <th>{{ $t('number') }}</th>
                          <th>{{ $t('customer.customer_and_service_name') }}</th>
                          <th class="text-center">{{ $t('tax.tax_id', { taxId: '' }) }}</th>
                          <th class="text-center">{{ $t('market.main_and_branch_office') }}</th>
                          <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.no_tax') }}</th>
                          <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.before_tax') }}</th>
                          <th class="text-center">{{ $t('tax.title') }}<br />{{ $t('tax.vat') }}</th>
                          <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.total_tax') }}</th>
                        </tr>
                        <tr>
                          <td class="text-center">-</td>
                          <td class="text-center">-</td>
                          <td class="text-center">-</td>
                          <td class="text-center">-</td>
                          <td class="text-center">-</td>
                          <td class="text-right">-</td>
                          <td class="text-right">-</td>
                          <td class="text-right">-</td>
                          <td class="text-right">-</td>
                        </tr>
                        <tr>
                          <td colspan="4"></td>
                          <td class="text-center"><b>{{ $t('sum') }}</b></td>
                          <td class="text-right">{{ 0 | currency }}</td>
                          <td class="text-right">{{ 0 | currency }}</td>
                          <td class="text-right">{{ 0 | currency }}</td>
                          <td class="text-right">{{ 0 | currency }}</td>
                        </tr>
                      </table>
                      <div style="border-top: 1px solid black; margin-top: 10px">
                        ({{ $t('receipt.receipt_count', { count: 0 }) }})
                      </div>
                    </div>
                  </section>
                </template>
              </div>
            </template>

            <template
              v-if="isEmpty(invoiceVatGroup) && isEmpty(invoiceNonGroup) && (typeSelectInvoice == 'split_group' || typeSelectInvoice == 'split_non_group')">
              <template v-for="chunk in 2">
                <template v-for="(mk, index) in markets">
                  <div class="paper A4" v-if="typeOnButtonInvoice == 'showFirstMarket' && index == 0">
                    <template>
                      <section class="sheet" id="sheet">
                        <div class="page" style="padding: 5mm; font-size: 13px;">
                          <table width="100%" style="font-weight: bold; font-size: 13px;margin-bottom: 7px;">
                            <tr>
                              <td>{{ $t('tax.tax_sell_report') }}</td>
                              <td class="text-right">{{ $t('page_message', { page: 1, total: 1 }) }}</td>
                            </tr>
                          </table>
                          <table width="100%" style="font-weight: bold; font-size: 13px;">
                            <tr>
                              <td width="20%">{{ $t('market.business_owner_name') }}</td>
                              <td>
                                <template v-if="mk.companyData && mk.companyData.name">
                                  {{ mk.companyData.name }}
                                </template>
                                <template v-else>
                                  {{ mk.name }}
                                </template>
                              </td>
                              <td width="20%">
                                <div
                                  v-if="!mk.companyData || !mk.companyData.branchName || mk.companyData.branchName == 'สำนักงานใหญ่'"
                                  style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <title>checkbox-outline</title>
                                    <path
                                      d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                                  </svg>
                                </div>
                                <div v-else
                                  style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <title>checkbox-blank-outline</title>
                                    <path
                                      d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                                  </svg>
                                </div>
                                {{ $t('market.main_office') }}
                              </td>
                            </tr>
                            <tr>
                              <td>{{ $t('market.business_name') }}</td>
                              <td>
                                <template v-if="mk.companyData && mk.companyData.name">
                                  {{ mk.companyData.name }}
                                </template>
                                <template v-else>
                                  {{ mk.name }}
                                </template>
                              </td>
                              <td>
                                <template
                                  v-if="!mk.companyData || !mk.companyData.branchName || mk.companyData.branchName == 'สำนักงานใหญ่'">
                                  <div
                                    style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                      <title>checkbox-blank-outline</title>
                                      <path
                                        d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                                    </svg>
                                  </div>
                                  {{ $t('market.branch_office_number', { number: '' }) }} . . . . .
                                </template>
                                <template v-else>
                                  <div
                                    style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                      <title>checkbox-outline</title>
                                      <path
                                        d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                                    </svg>
                                  </div>
                                  {{ $t('market.branch_office_number', { number: mk.companyData ? mk.companyData.branchName : '' }) }}
                                </template>
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>{{ mk.companyData ? mk.companyData.address : '' }}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="3">{{ $t('tax.tax_id', { taxId: mk.companyData ? mk.companyData.taxId : '' }) }}
                              </td>
                            </tr>
                            <tr>
                              <td>{{ $t('receipt.print_date', { date: $moment().format("DD/MM/YYYY") }) }}</td>
                              <td class="text-center">{{ $t('receipt.print_date_range', { startDate: $moment(tempDate.startDate).format("DD/MM/YYYY"), endDate: $moment(tempDate.endDate).format("DD/MM/YYYY") }) }}</td>
                              <td class="text-right">{{ $t('receipt.print_time', { time: $moment().format("HH:mm") }) }}</td>
                            </tr>
                          </table>
                          <table width="100%" class="report-vat-table">
                            <tr style="border-top: 1px solid black;border-bottom: 1px solid black;">
                              <th class="text-center">{{ $t('day') }} {{ $t('month') }} {{ $t('year') }}</th>
                              <th>{{ $t('number') }}</th>
                              <th>{{ $t('customer.customer_and_service_name') }}</th>
                              <th class="text-center">{{ $t('tax.tax_id', { taxId: '' }) }}</th>
                              <th class="text-center">{{ $t('market.main_and_branch_office') }}</th>
                              <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.no_tax') }}</th>
                              <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.before_tax') }}</th>
                              <th class="text-center">{{ $t('tax.title') }}<br />{{ $t('tax.vat') }}</th>
                              <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.total_tax') }}</th>
                            </tr>
                            <tr>
                              <td class="text-center">-</td>
                              <td class="text-center">-</td>
                              <td class="text-center">-</td>
                              <td class="text-center">-</td>
                              <td class="text-center">-</td>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                            </tr>
                            <tr>
                              <td colspan="4"></td>
                              <td class="text-center"><b>{{ $t('sum') }}</b></td>
                              <td class="text-right">{{ 0 | currency }}</td>
                              <td class="text-right">{{ 0 | currency }}</td>
                              <td class="text-right">{{ 0 | currency }}</td>
                              <td class="text-right">{{ 0 | currency }}</td>
                            </tr>
                          </table>
                          <div style="border-top: 1px solid black; margin-top: 10px">
                            ({{ $t('receipt.receipt_count', { count: 0 }) }})
                          </div>
                        </div>
                      </section>
                    </template>
                  </div>

                  <template v-else-if="typeOnButtonInvoice == 'showAllMarket'">
                    <div class="paper A4">
                      <section class="sheet" id="sheet">
                        <div class="page" style="padding: 5mm; font-size: 13px;">
                          <table width="100%" style="font-weight: bold; font-size: 13px;margin-bottom: 7px;">
                            <tr>
                              <td>{{ $t('tax.tax_sell_report') }}</td>
                              <td class="text-right">{{ $t('page_message', { page: 1, total: 1 }) }}</td>
                            </tr>
                          </table>
                          <table width="100%" style="font-weight: bold; font-size: 13px;">
                            <tr>
                              <td width="20%">{{ $t('market.business_owner_name') }}</td>
                              <td>
                                <template v-if="mk.companyData && mk.companyData.name">
                                  {{ mk.companyData.name }}
                                </template>
                                <template v-else>
                                  {{ mk.name }}
                                </template>
                              </td>
                              <td width="20%">
                                <div
                                  v-if="!mk.companyData || !mk.companyData.branchName || mk.companyData.branchName == 'สำนักงานใหญ่'"
                                  style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <title>checkbox-outline</title>
                                    <path
                                      d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                                  </svg>
                                </div>
                                <div v-else
                                  style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <title>checkbox-blank-outline</title>
                                    <path
                                      d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                                  </svg>
                                </div>
                                {{ $t('market.main_office') }}
                              </td>
                            </tr>
                            <tr>
                              <td>{{ $t('market.business_name') }}</td>
                              <td>
                                <template v-if="mk.companyData && mk.companyData.name">
                                  {{ mk.companyData.name }}
                                </template>
                                <template v-else>
                                  {{ mk.name }}
                                </template>
                              </td>
                              <td>
                                <template
                                  v-if="!mk.companyData || !mk.companyData.branchName || mk.companyData.branchName == 'สำนักงานใหญ่'">
                                  <div
                                    style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                      <title>checkbox-blank-outline</title>
                                      <path
                                        d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                                    </svg>
                                  </div>
                                  {{ $t('market.branch_office_number', { number: '' }) }} . . . . .
                                </template>
                                <template v-else>
                                  <div
                                    style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                      <title>checkbox-outline</title>
                                      <path
                                        d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                                    </svg>
                                  </div>
                                  {{ $t('market.branch_office_number', { number: mk.companyData ? mk.companyData.branchName : '' }) }}
                                </template>
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>{{ mk.companyData ? mk.companyData.address : '' }}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="3">{{ $t('tax.tax_id', { taxId: mk.companyData ? mk.companyData.taxId : '' }) }}
                              </td>
                            </tr>
                            <tr>
                              <td>{{ $t('receipt.print_date', { date: $moment().format("DD/MM/YYYY") }) }}</td>
                              <td class="text-center">{{ $t('receipt.print_date_range', { startDate: $moment(tempDate.startDate).format("DD/MM/YYYY"), endDate: $moment(tempDate.endDate).format("DD/MM/YYYY") }) }}</td>
                              <td class="text-right">{{ $t('receipt.print_time', { time: $moment().format("HH:mm") }) }}</td>
                            </tr>
                          </table>
                          <table width="100%" class="report-vat-table">
                            <tr style="border-top: 1px solid black;border-bottom: 1px solid black;">
                              <th class="text-center">{{ $t('day') }} {{ $t('month') }} {{ $t('year') }}</th>
                              <th>{{ $t('number') }}</th>
                              <th>{{ $t('customer.customer_and_service_name') }}</th>
                              <th class="text-center">{{ $t('tax.tax_id', { taxId: '' }) }}</th>
                              <th class="text-center">{{ $t('market.main_and_branch_office') }}</th>
                              <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.no_tax') }}</th>
                              <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.before_tax') }}</th>
                              <th class="text-center">{{ $t('tax.title') }}<br />{{ $t('tax.vat') }}</th>
                              <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.total_tax') }}</th>
                            </tr>
                            <tr>
                              <td class="text-center">-</td>
                              <td class="text-center">-</td>
                              <td class="text-center">-</td>
                              <td class="text-center">-</td>
                              <td class="text-center">-</td>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                            </tr>
                            <tr>
                              <td colspan="4"></td>
                              <td class="text-center"><b>{{ $t('sum') }}</b></td>
                              <td class="text-right">{{ 0 | currency }}</td>
                              <td class="text-right">{{ 0 | currency }}</td>
                              <td class="text-right">{{ 0 | currency }}</td>
                              <td class="text-right">{{ 0 | currency }}</td>
                            </tr>
                          </table>
                          <div style="border-top: 1px solid black; margin-top: 10px">
                            ({{ $t('receipt.receipt_count', { count: 0 }) }})
                          </div>
                        </div>
                      </section>
                    </div>
                  </template>
                </template>
              </template>
            </template>

            <template v-if="invoiceVatGroup">
              <div v-for="(inv, inx) in invoiceVatGroup">
                <div class="paper A4" v-for="(checks, index) in inv.chunk" :key="'paper_' + index">
                  <section class="sheet" id="sheet">
                    <div class="page" style="padding: 5mm; font-size: 13px;">
                      <table width="100%" style="font-weight: bold; font-size: 13px;margin-bottom: 7px;">
                        <tr>
                          <td>{{ $t('tax.tax_sell_report') }}</td>
                          <td class="text-right">{{ $t('page_message', { page: index + 1, total: inv.chunk.length }) }}</td>
                        </tr>
                      </table>
                      <table width="100%" style="font-weight: bold; font-size: 13px;">
                        <tr>
                          <td width="20%">{{ $t('market.business_owner_name') }}</td>
                          <td>
                            <template v-if="inv.market.companyData && inv.market.companyData.name">
                              {{ inv.market.companyData.name }}
                            </template>
                            <template v-else>
                              {{ inv.market.name }}
                            </template>
                          </td>
                          <td width="20%">
                            <div
                              v-if="!inv.market.companyData || !inv.market.companyData.branchName || inv.market.companyData.branchName == 'สำนักงานใหญ่'"
                              style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <title>checkbox-outline</title>
                                <path
                                  d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                              </svg>
                            </div>
                            <div v-else
                              style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <title>checkbox-blank-outline</title>
                                <path
                                  d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                              </svg>
                            </div>
                            {{ $t('market.main_office') }}
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t('market.business_name') }}</td>
                          <td>
                            <template v-if="inv.market.companyData && inv.market.companyData.name">
                              {{ inv.market.companyData.name }}
                            </template>
                            <template v-else>
                              {{ inv.market.name }}
                            </template>
                          </td>
                          <td>
                            <template
                              v-if="!inv.market.companyData || !inv.market.companyData.branchName || inv.market.companyData.branchName == 'สำนักงานใหญ่'">
                              <div
                                style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <title>checkbox-blank-outline</title>
                                  <path
                                    d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                                </svg>
                              </div>
                              {{ $t('market.branch_office_number', { number: '' }) }} . . . . .
                            </template>
                            <template v-else>
                              <div
                                style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <title>checkbox-outline</title>
                                  <path
                                    d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                                </svg>
                              </div>
                              {{ $t('market.branch_office_number', { number: inv.market.companyData ? inv.market.companyData.branchName : '' }) }}
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>{{ inv.market.companyData ? inv.market.companyData.address : '' }}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="3">{{ $t('tax.tax_id', { taxId: inv.market.companyData ? inv.market.companyData.taxId : '' }) }}</td>
                        </tr>
                        <tr>
                          <td>{{ $t('receipt.print_date', { date: $moment().format("DD/MM/YYYY") }) }}</td>
                          <td class="text-center">{{ $t('receipt.print_date_range', { startDate: $moment(tempDate.startDate).format("DD/MM/YYYY"), endDate: $moment(tempDate.endDate).format("DD/MM/YYYY") }) }}</td>
                          <td class="text-right">{{ $t('receipt.print_time', { time: $moment().format("HH:mm") }) }}</td>
                        </tr>
                      </table>
                      <table width="100%" class="report-vat-table">
                        <tr style="border-top: 1px solid black;border-bottom: 1px solid black;">
                          <th class="text-center">{{ $t('day') }} {{ $t('month') }} {{ $t('year') }}</th>
                          <th>{{ $t('number') }}</th>
                          <th>{{ $t('customer.customer_and_service_name') }}</th>
                          <th class="text-center">{{ $t('tax.tax_id', { taxId: '' }) }}</th>
                          <th class="text-center">{{ $t('market.main_and_branch_office') }}</th>
                          <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.no_tax') }}</th>
                          <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.before_tax') }}</th>
                          <th class="text-center">{{ $t('tax.title') }}<br />{{ $t('tax.vat') }}</th>
                          <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.total_tax') }}</th>
                        </tr>
                        <template v-if="checks.length > 0">
                          <tr v-for="(invoice) in checks" :key="invoice.objectId" style="vertical-align: baseline;">
                            <td class="text-center">{{ $moment(invoice.date).format("DD/MM/YYYY") }}</td>
                            <td>{{ invoice.documentId }}</td>
                            <td>
                              <span v-if="invoice.isSent && !invoice.isBadDebt">
                                {{ invoice.customerData.name }}
                              </span>
                              <span v-else>
                                ** CANCELLED **
                              </span>
                            </td>
                            <td class="text-center"><span>{{ invoice.customerData.taxId || "-" }}</span></td>
                            <td class="text-center">
                              <template
                                v-if="invoice.contract && invoice.contract.customer && invoice.contract.customer.type == 'company'">
                                <template
                                  v-if="!invoice.customerData.branchName || invoice.customerData.branchName == 'สำนักงานใหญ่'">
                                  {{ $t('market.main_office_short') }}
                                </template>
                                <template v-else>
                                  {{ invoice.customerData.branchName }}
                                </template>
                              </template>
                              <template
                                v-else-if="invoice.booking && invoice.booking.customer && invoice.booking.customer.type == 'company'">
                                <template
                                  v-if="!invoice.customerData.branchName || invoice.customerData.branchName == 'สำนักงานใหญ่'">
                                  {{ $t('market.main_office_short') }}
                                </template>
                                <template v-else>
                                  {{ invoice.customerData.branchName }}
                                </template>
                              </template>
                              <template
                                v-else-if="invoice.contractCheckOut && invoice.contractCheckOut.contract && invoice.contractCheckOut.contract.customer && invoice.contractCheckOut.contract.customer.type == 'company'">
                                <template
                                  v-if="!invoice.customerData.branchName || invoice.customerData.branchName == 'สำนักงานใหญ่'">
                                  {{ $t('market.main_office_short') }}
                                </template>
                                <template v-else>
                                  {{ invoice.customerData.branchName }}
                                </template>
                              </template>
                            </td>
                            <td class="text-right">
                              <template v-if="invoice.totalNonVatItemsValue && invoice.isSent && !invoice.isBadDebt">
                                {{ invoice.totalNonVatItemsValue | currency }}
                              </template>
                              <template v-else>-</template>
                            </td>
                            <template v-if="invoice.isSent && !invoice.isBadDebt">
                              <td class="text-right">{{ invoice.totalVatItemsValue | currency }}</td>
                              <td class="text-right">{{ invoice.totalVatValue | currency }}</td>
                              <td class="text-right">{{ invoice.totalValue | currency }}</td>
                            </template>
                            <template v-else>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                            </template>
                          </tr>
                        </template>
                        <template v-else>
                          <tr>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                          </tr>
                        </template>
                        <tr v-if="inv.chunk.length > 0 && index == inv.chunk.length - 1">
                          <td colspan="4"></td>
                          <td class="text-center"><b>{{ $t('sum') }}</b></td>
                          <td class="text-right">{{ inv.summary.totalNonVatItemsValue | currency }}</td>
                          <td class="text-right">{{ inv.summary.totalVatItemsValue | currency }}</td>
                          <td class="text-right">{{ inv.summary.totalVatValue | currency }}</td>
                          <td class="text-right">{{ inv.summary.totalValue | currency }}</td>
                        </tr>
                      </table>
                      <div style="border-top: 1px solid black; margin-top: 10px">
                        ({{ $t('receipt.receipt_count', { count: checks ? checks.length : 0 }) }})
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </template>
            <template v-if="invoiceNonGroup">
              <div v-for="(inv_nonvat, inx) in invoiceNonGroup">
                <div class="paper A4" v-for="(checks, index) in inv_nonvat.chunk" :key="'paper_nonvat_' + index">
                  <section class="sheet" id="sheet">
                    <div class="page" style="padding: 5mm; font-size: 13px;">
                      <table width="100%" style="font-weight: bold; font-size: 13px;margin-bottom: 7px;">
                        <tr>
                          <td>{{ $t('tax.tax_sell_report') }}</td>
                          <td class="text-right">{{ $t('page_message', { page: index + 1, total: inv_nonvat.chunk.length }) }}</td>
                        </tr>
                      </table>
                      <table width="100%" style="font-weight: bold; font-size: 13px;">
                        <tr>
                          <td width="20%">{{ $t('market.business_owner_name') }}</td>
                          <td>
                            <template v-if="inv_nonvat.market.companyData && inv_nonvat.market.companyData.name">
                              {{ inv_nonvat.market.companyData.name }}
                            </template>
                            <template v-else>
                              {{ inv_nonvat.market.name }}
                            </template>
                          </td>
                          <td width="20%">
                            <div
                              v-if="!inv_nonvat.market.companyData || !inv_nonvat.market.companyData.branchName || inv_nonvat.market.companyData.branchName == 'สำนักงานใหญ่'"
                              style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <title>checkbox-outline</title>
                                <path
                                  d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                              </svg>
                            </div>
                            <div v-else
                              style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <title>checkbox-blank-outline</title>
                                <path
                                  d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                              </svg>
                            </div>
                            {{ $t('market.main_office') }}
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t('market.business_name') }}</td>
                          <td>
                            <template v-if="inv_nonvat.market.companyData && inv_nonvat.market.companyData.name">
                              {{ inv_nonvat.market.companyData.name }}
                            </template>
                            <template v-else>
                              {{ inv_nonvat.market.name }}
                            </template>
                          </td>
                          <td>
                            <template
                              v-if="!inv_nonvat.market.companyData || !inv_nonvat.market.companyData.branchName || inv_nonvat.market.companyData.branchName == 'สำนักงานใหญ่'">
                              <div
                                style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <title>checkbox-blank-outline</title>
                                  <path
                                    d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                                </svg>
                              </div>
                              {{ $t('market.branch_office_number', { number: '' }) }} . . . . .
                            </template>
                            <template v-else>
                              <div
                                style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <title>checkbox-outline</title>
                                  <path
                                    d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                                </svg>
                              </div>
                              {{ $t('market.branch_office_number', { number: inv_nonvat.market.companyData ? inv_nonvat.market.companyData.branchName : '' }) }}
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>{{ inv_nonvat.market.companyData ? inv_nonvat.market.companyData.address : '' }}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="3">{{ $t('tax.tax_id', { taxId: inv_nonvat.market.companyData ? inv_nonvat.market.companyData.taxId : '' }) }}</td>
                        </tr>
                        <tr>
                          <td>{{ $t('receipt.print_date', { date: $moment().format("DD/MM/YYYY") }) }}</td>
                          <td class="text-center">{{ $t('receipt.print_date_range', { startDate: $moment(tempDate.startDate).format("DD/MM/YYYY"), endDate: $moment(tempDate.endDate).format("DD/MM/YYYY") }) }}</td>
                          <td class="text-right">{{ $t('receipt.print_time', { time: $moment().format("HH:mm") }) }}</td>
                        </tr>
                      </table>
                      <table width="100%" class="report-vat-table">
                        <tr style="border-top: 1px solid black;border-bottom: 1px solid black;">
                          <th class="text-center">{{ $t('day') }} {{ $t('month') }} {{ $t('year') }}</th>
                          <th>{{ $t('number') }}</th>
                          <th>{{ $t('customer.customer_and_service_name') }}</th>
                          <th class="text-center">{{ $t('tax.tax_id', { taxId: '' }) }}</th>
                          <th class="text-center">{{ $t('market.main_and_branch_office') }}</th>
                          <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.no_tax') }}</th>
                          <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.before_tax') }}</th>
                          <th class="text-center">{{ $t('tax.title') }}<br />{{ $t('tax.vat') }}</th>
                          <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.total_tax') }}</th>
                        </tr>
                        <template v-if="checks.length > 0">
                          <tr v-for="(invoice) in checks" :key="invoice.objectId" style="vertical-align: baseline;">
                            <td class="text-center">{{ $moment(invoice.date).format("DD/MM/YYYY") }}</td>
                            <td>{{ invoice.documentId }}</td>
                            <td>
                              <span v-if="invoice.isSent && !invoice.isBadDebt">
                                {{ invoice.customerData.name }}
                              </span>
                              <span v-else>
                                ** CANCELLED **
                              </span>
                            </td>
                            <td class="text-center"><span>{{ invoice.customerData.taxId || "-" }}</span></td>
                            <td class="text-center">
                              <template
                                v-if="invoice.contract && invoice.contract.customer && invoice.contract.customer.type == 'company'">
                                <template
                                  v-if="!invoice.customerData.branchName || invoice.customerData.branchName == 'สำนักงานใหญ่'">
                                  {{ $t('market.main_office_short') }}
                                </template>
                                <template v-else>
                                  {{ invoice.customerData.branchName }}
                                </template>
                              </template>
                              <template
                                v-else-if="invoice.booking && invoice.booking.customer && invoice.booking.customer.type == 'company'">
                                <template
                                  v-if="!invoice.customerData.branchName || invoice.customerData.branchName == 'สำนักงานใหญ่'">
                                  {{ $t('market.main_office_short') }}
                                </template>
                                <template v-else>
                                  {{ invoice.customerData.branchName }}
                                </template>
                              </template>
                              <template
                                v-else-if="invoice.contractCheckOut && invoice.contractCheckOut.contract && invoice.contractCheckOut.contract.customer && invoice.contractCheckOut.contract.customer.type == 'company'">
                                <template
                                  v-if="!invoice.customerData.branchName || invoice.customerData.branchName == 'สำนักงานใหญ่'">
                                  {{ $t('market.main_office_short') }}
                                </template>
                                <template v-else>
                                  {{ invoice.customerData.branchName }}
                                </template>
                              </template>
                            </td>
                            <td class="text-right">
                              <template v-if="invoice.totalNonVatItemsValue && invoice.isSent && !invoice.isBadDebt">
                                {{ invoice.totalNonVatItemsValue | currency }}
                              </template>
                              <template v-else>-</template>
                            </td> 
                            <template v-if="invoice.isSent && !invoice.isBadDebt">
                              <td class="text-right">{{ invoice.totalVatItemsValue | currency }}</td>
                              <td class="text-right">{{ invoice.totalVatValue | currency }}</td>
                              <td class="text-right">{{ invoice.totalValue | currency }}</td>
                            </template>
                            <template v-else>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                            </template>
                          </tr>
                        </template>
                        <template v-else>
                          <tr>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                          </tr>
                        </template>
                        <tr
                          v-if="inv_nonvat.chunk && inv_nonvat.chunk.length > 0 && index == inv_nonvat.chunk.length - 1">
                          <td colspan="4"></td>
                          <td class="text-center"><b>{{ $t('sum') }}</b></td>
                          <td class="text-right">{{ inv_nonvat.summary.totalNonVatItemsValue | currency }}</td>
                          <td class="text-right">{{ inv_nonvat.summary.totalVatItemsValue | currency }}</td>
                          <td class="text-right">{{ inv_nonvat.summary.totalVatValue | currency }}</td>
                          <td class="text-right">{{ inv_nonvat.summary.totalValue | currency }}</td>
                        </tr>
                      </table>
                      <div style="border-top: 1px solid black; margin-top: 10px">
                        ({{ $t('receipt.receipt_count', { count: checks ? checks.length : 0 }) }})
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </template>

          </div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" @click="isPrintReportVat = false">{{ $t('close') }}</v-btn>
          <v-btn color="info" @click="printReportVat()">
            <v-icon dark class="me-2">mdi-printer</v-icon>{{ $t('print') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import InvoiceDialog from "@/components/InvoiceDialog.component";
import SelectMonthYear from "@/components/SelectMonthYear.component";
import ParentBar from "@/components/ParentBar.vue";
import AccountingParentBar from "../../components/AccountingParentBar.component";
import { ExportAccounting, ExportMango } from "../../exports";
import Layout from "@/components/Layout.vue";
import { mapState } from "vuex";
import { Invoice, Market } from "../../classes";
import PrintDialog from "../../components/PrintDialog.component.vue";
import CardInvoiceOverAll from "@/components/CardInvoiceOverAll.component.vue";
export default {
  computed: {
    ...mapState({
      invoices: state => state.invoice.invoices,
      contracts: state => state.contract.contracts
    }),
    hashArea() {
      return this.$store.getters["area/getHashArea"];
    },
    dataTable() {
      return {
        headers: [
          {
            text: this.$t('date'),
            value: "date",
            width: "8%",
            align: "center"
          },
          {
            text: this.$t('market.market'),
            value: "marketName",
            width: "1%",
            align: "center hd-resize",
            class : 'custom-sort',
            filter: d =>
              this.filterData.marketName
                ? d
                  .toLowerCase()
                  .includes(this.filterData.marketName.toLowerCase())
                : d
          },
          {
            text: this.$t('market.document_id'),
            value: "documentId",
            width: "12%",
            align: "center",
            filter: d =>
              this.filterData.documentId
                ? d
                  .toLowerCase()
                  .includes(this.filterData.documentId.toLowerCase())
                : d
          },
          {
            text: this.$t('type'),
            width: "12%",
            value: "documentTypeString",
            align: "center",
            filter: d =>
              this.filterData.documentType
                ? d == this.filterData.documentType
                : d
          },
          {
            text: this.$t('market.market_title'),
            width: "1%",
            value: "areaName",
            align: "center hd-resize",
            class : 'custom-sort',
            filter: d =>
              this.filterData.areaName
                ? d
                  .toLowerCase()
                  .includes(this.filterData.areaName.toLowerCase())
                : d
          },
          {
            text: this.$t('market.marchant_name'),
            value: "customerDataName",
            align: "center hd-resize",
            width: "1%",
            class : 'custom-sort',
            filter: d =>
              this.filterData.customerName
                ? d
                  .toLowerCase()
                  .includes(this.filterData.customerName.toLowerCase())
                : d
          },
          {
            text: this.$t('market.total_value'),
            value: "totalValue",
            width: "10%",
            align: "center",
            filter: d =>
              this.filterData.totalValue
                ? d.toString().includes(this.filterData.totalValue)
                : d || d === 0
          },
          {
            text: this.$t('payment.currency'),
            value: "currencyCode",
            align: `center ${this.$helper.currencyOptions.length <= 1 ? 'd-none' : ''}`,
            filter: d =>
              this.filterData.currencyCode ? d == this.filterData.currencyCode : d
          },
          {
            text: this.$t('status'),
            value: "status",
            align: "center",
            filter: d =>
              this.filterData.status ? d == this.filterData.status : d
          }
        ],
        data: this.invoices
      };
    },
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      markets: [],
      project: null,
      isInvoiceDialog: false,
      selectedMonthYear: null,
      isError: false,
      isLoading: false,
      isFirstLoading: true,
      invoiceId: null,
      menuStartDate: false,
      menuEndDate: false,
      isFristTime: true,
      formData: {
        startDate: this.$moment({ day: 1 }).format("YYYY-MM-DD"),
        endDate: this.$moment()
          .endOf("month")
          .format("YYYY-MM-DD")
      },
      tempDate: null,
      isShowSelectPrintInvoice: false,
      selectedInvoices: [],
      isPrintDialog: false,
      filterData: {
        documentId: null,
        documentType: null,
        areaName: null,
        customerName: null,
        totalValue: null,
        status: null,
        marketName: null,
        currencyCode: null
      },
      filterOption: {
        documentType: [
          {
            text: this.$t('bill.document_type.1')
          },
          {
            text: this.$t('bill.deposit_bill')
          },
          {
            text: this.$t('bill.checkin_bill')
          },
          {
            text: this.$t('payment.checkout_bill')
          },
          {
            text: this.$t('bill.other_bill')
          },
          {
            text: this.$t('payment.installment_bill')
          },
          {
            text: this.$t('payment.daily_booth')
          },
          {
            text: this.$t('payment.monthly_booking')
          }
        ],
        status: [
          {
            text: this.$t('payment.paid')
          },
          {
            text: this.$t('payment.pending')
          },
          {
            text: this.$t('bill.edit_bill')
          },
          {
            text: this.$t('bill.cancel')
          },
          {
            text: this.$t('bill.bad_debt')
          }
        ],
      },
      isPrintReportVat: false,
      invoiceNonGroup: {},
      invoiceVatGroup: {},
      creditNotes: null,
      typeOnButtonInvoice: null,
      typeSelectInvoice: null,
      tab: this.$globalCurrencyCode,
      isLoadingCardOverAll: false,
      filteredInvoices: [],
      loadedExportInvoices: false,
      fullExportInvoices: [],
      isLoadingExportToERP: false,
      isLoadingExportExcel: false,
      isLoadingReportVat: false,
    };
  },
  components: {
    InvoiceDialog,
    SelectMonthYear,
    ParentBar,
    AccountingParentBar,
    Layout,
    PrintDialog,
    CardInvoiceOverAll
  },
  async created() {
    this.markets = await Market.getMarketByProject(this.projectId);
    this.project = this.markets[0] ? this.markets[0].project : null;
  },
  methods: {
    async initData() {
      this.isLoading = true;
      this.isFirstLoading = true;
      this.isFristTime = false
      this.loadedExportInvoices = false;
      this.fullExportInvoices = [];
      this.$store.commit("invoice/setInvoiceExport", []);
      try {
        this.clearFilter();
        this.selectedInvoices = [];
        this.tempDate = JSON.parse(JSON.stringify(this.formData));
        this.invoicesSelect = [
          "documentId",
          "documentType",
          "customerData",
          "market.name",
          "contract",
          "date",
          "isPaid",
          "isSent",
          "totalValue",
          "items.area.name",
          "currencyCode",
          "currencyRate",
          "isBadDebt",
          "isCancelled",
        ]
        let params = {
          projectId: this.projectId,
          startDate: this.$moment(this.formData.startDate).startOf("day").toISOString(),
          endDate: this.$moment(this.formData.endDate).endOf("day").toISOString()
        };
        this.$store.commit("invoice/setInvoices", []);
        await this.$helper.queryMore(
          Invoice.getInvoicesBetweenDateByProject,
          {...params, select: this.invoicesSelect, isRaw: true},
          null,
          (results) => {
            this.$store.commit("invoice/addInvoices", results);
            this.isFirstLoading = false;
          }
        );
        this.isFirstLoading = false;
        this.isLoading = false;
        this.filteredInvoices = this.$refs.dataTableInvoice.$children[0].filteredItems;
      } catch (error) {
        console.error(error);
        this.isFirstLoading = false;
        this.isLoading = false;
        this.isError = true;
      }
    },
    groupByObjectId(array) {
      return array.reduce((acc, item) => {
        const key = item.market.objectId;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        return acc;
      }, {});
    },
    // async exportInvoice() {
    //   this.isLoading = true
    //   try{
    //     let contracts = await this.$store.dispatch("contract/getNewContractsBetweenDateByMarket", {
    //       marketId: this.marketId,
    //       startDate: this.$moment(this.formData.startDate).startOf("day").toISOString(),
    //       endDate: this.$moment(this.formData.endDate).endOf("day").toISOString(),
    //     });
    //     // let recurringInvoices = await RecurringInvoice.getRecurringInvoicesBetweenDateByMarket(
    //     //   this.marketId,
    //     //   this.$moment(this.formData.startDate).startOf("day").toISOString(),
    //     //   this.$moment(this.formData.endDate).endOf("day").toISOString(),
    //     // )
    //     let invoices = this.invoices.filter(d => { return d.isSent })

    //     await ExportSAGE.exportInvoiceZip(invoices, contracts);
    //     this.isLoading = false
    //   }catch(error){
    //     console.log(error)
    //     this.isLoading = false
    //     this.isError = true
    //   }
    // },
    hashing(datas) {
      let hash = {};
      for (let data of datas) {
        hash[data.objectId] = data;
      }
      return hash;
    },
    rowClick(invoice) {
      this.invoiceId = invoice.objectId;
      this.isInvoiceDialog = true;
    },
    getAreaName(items) {
      let name = [];
      for (let item of items) {
        if (item.area && item.area.name) {
          name.push(item.area.name);
        }
      }
      return [...new Set(name)].join(",") || "-";
    },
    choosePrintInvoice(type) {
      let filterInvoices = this.$refs.dataTableInvoice.$children[0].filteredItems
      this.selectedInvoices = [];
      if (type == "all") {
        this.selectedInvoices = filterInvoices.filter(d => d.isSent);
      } else if (type == "unpaid") {
        this.selectedInvoices = filterInvoices.filter(
          d => d.isSent && !d.isPaid
        );
      } else if (type == "paid") {
        this.selectedInvoices = filterInvoices.filter(d => d.isSent && d.isPaid);
      }
      this.isShowSelectPrintInvoice = true;
    },
    printInvoice(type) {
      let filterInvoices = this.$refs.dataTableInvoice.$children[0].filteredItems
      if (type == "all") {
        this.selectedInvoices = filterInvoices.filter(d => d.isSent);
      }
      this.isPrintDialog = true;
    },
    async exportInvoice() {
      this.isLoading = true;
      this.isLoadingExportExcel = true;
      try {
        const filterInvoices = this.$refs.dataTableInvoice.$children[0].filteredItems
        const ids = new Set(filterInvoices.map(d => d.objectId))
        const source = (this.$store.state.invoice.invoiceExport && this.$store.state.invoice.invoiceExport.length)
          ? this.$store.state.invoice.invoiceExport
          : await this.getFullExportInvoices();
        const exportInvoices = source.filter(inv => ids.has(inv.objectId))
        ExportAccounting.exportInvoiceList(
          exportInvoices,
          this.formData.startDate,
          this.formData.endDate,
          null,
          this.$globalVatPercent
        );
      } catch (err) {
        this.isError = true;
      } finally {
        this.isLoadingExportExcel = false;
        this.isLoading = false;
      }
    },
    printReportVat() {
      var PDF = document.getElementById("iframe-report-vat");
      PDF.focus();
      try {
        PDF.contentWindow.print();
      } catch (ex) {
        PDF.contentWindow.postMessage("print", "*");
      }
    },
    splitChunk(_data) {
      let data = []
      let i = 0
      let chunk = []
      for (let invoice of _data) {
        chunk.push(invoice)
        i++;
        if (invoice.customerData?.name?.length > 28 || (invoice.customerData && invoice.customerData.branchName && invoice.customerData.branchName != this.$t('market.main_office') && invoice.customerData.branchName.length > 10)) i++;
        if (i >= 45) {
          data.push(chunk)
          chunk = []
          i = 0
        }
      }
      if (chunk.length) data.push(chunk)
      return data.length ? data : []
    },
    splitChunkNonData(_data) {
      let data = []
      let i = 0
      let chunk = []
      for (let market of _data) {
        chunk.push(market)
        i++;
        if (i >= 1) {
          data.push(chunk)
          chunk = []
          i = 0
        }
      }
      if (chunk.length) data.push(chunk)
      return data.length ? data : []
    },
    summaryDataRepotVat(_data) {
      let totalNonVatItemsValue = 0
      let totalVatItemsValue = 0
      let totalVatValue = 0
      let totalValue = 0
      if (_data) {
        for (let invoice of _data) {
          if (invoice.isSent && !invoice.isBadDebt) {
            totalNonVatItemsValue += invoice.totalNonVatItemsValue
            totalVatItemsValue += invoice.totalVatItemsValue
            totalVatValue += invoice.totalVatValue
            totalValue += invoice.totalValue
          }
        }
      }
      return {
        totalNonVatItemsValue,
        totalVatItemsValue,
        totalVatValue,
        totalValue
      }
    },
    summaryDataRepotVatNonVat(_data) {
      let totalNonVatItemsValue = 0
      let totalVatItemsValue = 0
      let totalVatValue = 0
      let totalValue = 0
      if (_data) {
        for (let invoice of _data) {
          if (invoice.isSent && !invoice.isBadDebt) {
            totalNonVatItemsValue += invoice.totalNonVatItemsValue
            totalVatItemsValue += invoice.totalVatItemsValue
            totalVatValue += invoice.totalVatValue
            totalValue += invoice.totalValue
          }
        }
      }
      return {
        totalNonVatItemsValue,
        totalVatItemsValue,
        totalVatValue,
        totalValue
      }
    },
    async initReportVat(type) {
      this.isLoading = true;
      this.isLoadingReportVat = true;
      let _invoices = this.$refs.dataTableInvoice.$children[0].filteredItems.filter(d => d.documentId)
      const ids = new Set(_invoices.map(d => d.objectId))
      const source = (this.$store.state.invoice.invoiceExport && this.$store.state.invoice.invoiceExport.length)
        ? this.$store.state.invoice.invoiceExport
        : await this.getFullExportInvoices();
      let invoices = source.filter(d => ids.has(d.objectId)).map(d => new Invoice(d.data, true))
      this.invoiceVatGroup = {};
      this.invoiceNonGroup = {};
      let dataVat = null;
      let dataNonVat = null;
      this.typeSelectInvoice = type;
      if (type == "split_group") {
        dataVat = this.groupByObjectId(invoices.filter(d =>  d.totalVatValue))
        dataNonVat = this.groupByObjectId(invoices.filter(d => !d.totalVatValue))
      } else if (type == "split_non_group") {
        dataVat = invoices.filter(d => d.totalVatValue)
        dataNonVat = invoices.filter(d => !d.totalVatValue)
      } else if (type == "default_group") {
        dataVat = this.groupByObjectId(invoices)
        dataNonVat = null;
      } else if (type == "default_non_group") {
        dataVat = invoices
        dataNonVat = null;
      }

      if (invoices && invoices.length > 0) {
        if (type == "split_group" || type == "default_group") {
          if (dataVat) {
            for (let key in dataVat) {
              if (!this.invoiceVatGroup[key]) {
                this.invoiceVatGroup[key] = {
                  invoices: [],
                  chunk: [[]],
                  market: null,
                  summary: null,
                }
              }
              this.invoiceVatGroup[key].invoices = dataVat[key];
              this.invoiceVatGroup[key].chunk = this.splitChunk(dataVat[key]);
              this.invoiceVatGroup[key].market = dataVat[key][0].market;
              this.invoiceVatGroup[key].summary = this.summaryDataRepotVat(dataVat[key]);
            }
            for (let mk of this.markets) {
              if (!this.invoiceVatGroup[mk.objectId]) {
                this.invoiceVatGroup[mk.objectId] = {
                  invoices: [],
                  chunk: [[]],
                  market: mk,
                  summary: this.summaryDataRepotVat(),
                }
              }
            }
          }
          if (dataNonVat) {
            for (let key in dataNonVat) {
              if (!this.invoiceNonGroup[key]) {
                this.invoiceNonGroup[key] = {
                  invoices: [],
                  chunk: [[]],
                  market: null,
                  summary: null,
                }
              }
              this.invoiceNonGroup[key].invoices = dataNonVat[key];
              this.invoiceNonGroup[key].chunk = this.splitChunk(dataNonVat[key]);
              this.invoiceNonGroup[key].market = dataNonVat[key][0].market;
              this.invoiceNonGroup[key].summary = this.summaryDataRepotVatNonVat(dataNonVat[key]);
            }
            for (let mk of this.markets) {
              if (!this.invoiceNonGroup[mk.objectId]) {
                this.invoiceNonGroup[mk.objectId] = {
                  invoices: [],
                  chunk: [[]],
                  market: mk,
                  summary: this.summaryDataRepotVatNonVat(),
                }
              }
            }
          }
        } else {
          if (dataVat) {
            this.invoiceVatGroup = [
              {
                invoices: dataVat,
                chunk: this.splitChunk(dataVat),
                market: this.markets[0],
                summary: this.summaryDataRepotVat(dataVat)
              }
            ]
            this.invoiceVatGroup[0].market.name = this.project.name
          }
          if (dataNonVat) {
            this.invoiceNonGroup = [
              {
                invoices: dataNonVat,
                chunk: this.splitChunk(dataNonVat),
                market: this.markets[0],
                summary: this.summaryDataRepotVatNonVat(dataNonVat)
              }
            ]
            this.invoiceNonGroup[0].market.name = this.project.name
          }
        }
      } else {
        this.invoiceVatGroup = {};
        this.invoiceNonGroup = {};
        if (type == "split_group" || type == "default_group") {
          this.typeOnButtonInvoice = "showAllMarket"
        } else {
          this.typeOnButtonInvoice = "showFirstMarket"
        }
      }


      this.isPrintReportVat = true
      if (document.getElementById("iframe-report-vat")) {
        let PDF = document.getElementById("iframe-report-vat")
        PDF.contentWindow.document.body.innerHTML = ""
      }
      setTimeout(() => {
        let PDF = document.getElementById("iframe-report-vat")
        let data = document.getElementById("report-vat-data")
        PDF.contentWindow.document.head.innerHTML = `
          <style>
            @import url('https://fonts.googleapis.com/css2?family=Sarabun:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');
            body{
              margin: 0px;
            }
            * { 
              font-family: "Sarabun";
            }
            table {
              border-collapse: collapse;
            }
            .text-center{
              text-align: center;
            }
            .text-right{
              text-align: right;
            }
            @page { margin: 0 }
            .paper { margin: 0 }
            .sheet {
              margin: 0;
              overflow: hidden;
              position: relative;
              box-sizing: border-box;
              page-break-after: always;
            }

            /** Paper sizes **/
            .paper.A4               .sheet { width: 210mm; height: 296mm }


            /** For screen preview **/
            @media screen {
              .paper { background: #e0e0e0; padding: 5mm 0; }
              .sheet {
                background: white;
                box-shadow: 0 .5mm 2mm rgba(0,0,0,.3);
                margin: 0mm auto;
              }
            }

            /** Fix for Chrome issue #273306 **/
            @media print {
              .paper.A4, .paper.A5.landscape { width: 210mm }
            }

            table.report-vat-table {
              font-size: 12px;
              margin-top: 3px;
            }
            table.report-vat-table tr th:nth-child(1) {
              max-width:64px;
              width:64px;
            }
            table.report-vat-table tr th:nth-child(2) {
              max-width:96px;
              width:96px;
            }
            table.report-vat-table tr th:nth-child(3) {
              min-width:94px;
              max-width:200px;
            }
            table.report-vat-table tr th:nth-child(4),table.report-vat-table tr td:nth-child(4) {
              max-width:87px;
              width:87px;
            }
            table.report-vat-table tr th:nth-child(5) {
              max-width:55px;
              width:55px;
            }
            table.report-vat-table tr th:nth-child(6) {
              min-width:70px;
            }
            table.report-vat-table tr th:nth-child(7) {
              min-width:70px;
            }
            table.report-vat-table tr th:nth-child(8) {
              min-width:70px;
            }
            table.report-vat-table tr th:nth-child(9) {
              min-width:70px;
            }

            table.report-vat-table tr td{
              overflow-wrap: anywhere;
            }
              
            }
          </style>
        `
        PDF.contentWindow.document.body.innerHTML = data.innerHTML
      }, 200)
      this.isLoadingReportVat = false;
      this.isLoading = false;
    },
    async exportMangoInvoice() {
      this.isLoading = true;
      this.isLoadingExportToERP = true;
      try {
        const source = (this.$store.state.invoice.invoiceExport && this.$store.state.invoice.invoiceExport.length)
          ? this.$store.state.invoice.invoiceExport
          : await this.getFullExportInvoices();
        let invoices = source.filter(d => d.isSent);
        ExportMango.exportMango(invoices, "invoice", this.tempDate.startDate, this.tempDate.endDate);
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
        this.isError = true;
      } finally {
        this.isLoadingExportToERP = false;
        this.isLoading = false;
      }
    },
    async getFullExportInvoices() {
      if (!this.loadedExportInvoices) {
        let params = {
          projectId: this.projectId,
          startDate: this.$moment(this.formData.startDate).startOf("day").toISOString(),
          endDate: this.$moment(this.formData.endDate).endOf("day").toISOString()
        };
        this.fullExportInvoices = await this.$helper.queryMore(Invoice.getInvoicesBetweenDateByProject, params)
        this.$store.commit("invoice/setInvoiceExport", this.fullExportInvoices);
        this.loadedExportInvoices = true;
      }
      return this.fullExportInvoices;
    },
    isEmpty(obj) {
      return !obj || Object.keys(obj).length === 0;
    },
    onFilterChange() {
      if (this.$refs.dataTableInvoice) {
        this.filteredInvoices = this.$refs.dataTableInvoice.$children[0].filteredItems;
        this.isLoadingCardOverAll = true;
        setTimeout(() => {
          this.isLoadingCardOverAll = false;
        }, 100);
      }
    },
    clearFilter() {
      this.filterData = {
        documentId: null,
        documentType: null,
        areaName: null,
        customerName: null,
        businessName: null,
        totalValue: null,
        status: null,
        customerMarketId: "",
        currencyCode: null
      }
    },
  }
};
</script>

<style lang="scss" scoped>

.data-table-invoice::v-deep td.hd-resize {
  max-width: 150px;
}

.data-table-invoice::v-deep th.custom-sort {
  position: relative;
  .v-icon{
    position: absolute;
    right: 24px;
    top: 18px;
  }
}

.text-nowrap-table.market-name,
.text-nowrap-table.area-name,
.text-nowrap-table.customer-name {
  width: 100%;
}
</style>